<template>
  <div
    class="modal fade"
    id="withdrawalRuleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="withdrawalRuleModalLabel"
    aria-hidden="true"
    ref="modal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content border-0 shadow-lg">
        <div class="modal-body p-0">
          <!-- Header com gradiente -->
          <div
            class="p-4 text-center position-relative overflow-hidden"
            style="
              background: linear-gradient(135deg, #661cb0 0%, #a64bf4 100%);
            "
          >
            <div class="position-relative z-index-1">
              <div class="icon-box mb-3 mx-auto">
                <i class="material-icons text-white" style="font-size: 3rem"
                  >event_available</i
                >
              </div>
              <h4 class="text-white font-weight-bolder mb-1">
                Nova Regra de Saques
              </h4>
            </div>
          </div>

          <!-- Conteúdo -->
          <div class="p-4">
            <div class="mb-4 text-center">
              <p class="text-md text-dark mb-3">
                Na Carteira do Sistema, cada saque fica entre R$ 100,00 e R$ 3.000,00. A regra da semana continua valendo:
              </p>
              
              <div class="bg-light rounded p-3 text-start border-start border-primary border-4">
                <strong>De R$ 100,00 a R$ 3.000,00 por saque · 1 saque por semana</strong>
                <p class="text-sm text-muted mb-0 mt-1">
                  Você poderá solicitar até 1 saque a cada semana (de domingo a sábado). 
                  Se você tiver um saque aguardando aprovação ou já aprovado na semana atual, 
                  poderá solicitar um novo saque a partir do próximo domingo.
                </p>
              </div>
            </div>

            <div class="alert alert-light border mb-4">
              <div class="d-flex align-items-start">
                <i class="material-icons text-info me-2">info</i>
                <div class="text-sm">
                  Saques que forem <strong>recusados</strong> não entram na contagem, permitindo que você realize uma nova solicitação imediatamente.
                </div>
              </div>
            </div>

            <!-- Botões de ação -->
            <div class="d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-primary font-weight-bolder shadow-sm px-5"
                style="background: linear-gradient(135deg, #661cb0 0%, #a64bf4 100%); border: none;"
                @click="closeModal"
              >
                Ciente
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  name: "WithdrawalRuleModal",
  data() {
    return {
      modalInstance: null,
    };
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.modal, {
      backdrop: "static",
      keyboard: false,
    });
  },
  methods: {
    show() {
      this.modalInstance.show();
    },
    closeModal() {
      this.modalInstance.hide();
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.icon-box {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
